export const getStatusType = (value: number) =>
    value <= 3 ? "low" : value <= 4 ? "medium" : "high";
